<div class="ptf-tickets" uppDataid="ptf-tickets">
    <div
        *ngIf="!IsEmptyRecent || HasTableFilter"
        class="ptf-tickets__header"
        uppDataid="ptf-tickets-header"
    >
        <h2
            *ngIf="!IsEmptyRecent"
            class="ptf-tickets__title"
            uppDataid="ptf-tickets-title"
        >{{ Title }}</h2>
        <button
            *ngIf="HasTableFilter"
            type="button"
            class="ptf-tickets__filter"
            uppDataid="ptf-tickets-filter-chip"
            (click)="OnClearFilter()"
        >
            <span class="ptf-tickets__filter-label">{{ FilterLabel }}</span>
            <span class="ptf-tickets__filter-clear">{{ tr('@ptf_tickets_filter_clear') }}</span>
        </button>
    </div>

    <upp-scrollable uppDataid="ptf-tickets-scroll">
        <div *ngIf="IsEmptyRecent" class="ptf-tickets__empty" uppDataid="ptf-tickets-empty">
            <ion-card class="empty">
                <ion-icon color="success" name="checkmark-circle-outline"></ion-icon>
                <ion-card-header color="success">
                    <ion-card-title>{{ tr('@place_tickets_empty_title') }}</ion-card-title>
                    <ion-card-subtitle>{{ tr('@place_tickets_empty_message') }}</ion-card-subtitle>
                </ion-card-header>
            </ion-card>
        </div>

        <div
            *ngIf="RecentTickets.length"
            class="ptf-tickets__section"
            uppDataid="ptf-tickets-recent"
        >
            <upp-ticket-thumb
                *ngFor="let ticket of RecentTickets; trackBy: TicketTrack"
                mode="VIEW"
                [ticket]="ticket"
                [uppDataid]="'ptf-ticketthumb-' + (ticket.orderno || ticket._uuid) + '-thumb'"
                (click)="OnSelectTicket(ticket)"
            ></upp-ticket-thumb>
        </div>

        <div
            *ngIf="ShowPastSection"
            class="ptf-tickets__section ptf-tickets__section--past"
            uppDataid="ptf-tickets-past"
        >
            <div class="ptf-tickets__section-title" uppDataid="ptf-tickets-past-title">
                {{ tr('@place_tickets_old_tickets') }}
            </div>
            <upp-ticket-thumb
                *ngFor="let ticket of PastTickets; trackBy: TicketTrack"
                mode="VIEW"
                [ticket]="ticket"
                [uppDataid]="'ptf-ticketthumb-past-' + (ticket.orderno || ticket._uuid) + '-thumb'"
                (click)="OnSelectTicket(ticket)"
            ></upp-ticket-thumb>
        </div>
    </upp-scrollable>
</div>
